"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClientsApi = void 0;
var _react = require("@reduxjs/toolkit/query/react");
var _objects = require("../utilities/objects");
var _strings = require("../utilities/strings");
const createClientsApi = _ref => {
  let {
    baseUrl,
    slice,
    tokenName
  } = _ref;
  return (0, _react.createApi)({
    reducerPath: 'clientsApi',
    baseQuery: (0, _react.fetchBaseQuery)({
      baseUrl,
      credentials: 'include',
      prepareHeaders: (headers, _ref2) => {
        var _getState$slice;
        let {
          getState
        } = _ref2;
        const token = (_getState$slice = getState()[slice]) === null || _getState$slice === void 0 ? void 0 : _getState$slice[tokenName];
        if (token) {
          headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
      }
    }),
    endpoints: builder => ({
      loggedIn: builder.query({
        query: clientId => ({
          url: `/logged-in?clientId=${clientId || 'idm'}`
        }),
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      getIntegrations: builder.query({
        query: _ref3 => {
          let {
            params
          } = _ref3;
          return {
            url: `/clients${(0, _strings.objectToQueryString)(params)}`
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      getIntegrationById: builder.mutation({
        query: _ref4 => {
          let {
            clientId
          } = _ref4;
          return {
            url: `/clients/${clientId}`
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      createIntegration: builder.mutation({
        query: body => ({
          body,
          method: 'POST',
          url: '/clients'
        }),
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      updateIntegration: builder.mutation({
        query: _ref5 => {
          let {
            clientId,
            body
          } = _ref5;
          return {
            body,
            method: 'PATCH',
            url: `/clients/${clientId}`
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      }),
      deleteIntegration: builder.mutation({
        query: _ref6 => {
          let {
            clientId
          } = _ref6;
          return {
            method: 'DELETE',
            url: `/clients/${clientId}`
          };
        },
        transformResponse: response => (0, _objects.toCamelCase)(response)
      })
    })
  });
};
exports.createClientsApi = createClientsApi;